import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _templateObject;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { forwardRef } from 'react';
import { IconButton as MuiIconButton } from '@material-ui/core';
import { spacing } from '@material-ui/system';
import styled from 'styled-components';
var StyledIconButton = styled(MuiIconButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), spacing);

// eslint-disable-next-line react/display-name
export var IconButton = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(StyledIconButton, _extends({
    ref: ref
  }, props));
});